import { sharedHeaders } from "../utils/constants"

const getPurchaseDetails = {
  "type": "endpoint",
  "method": "get",
  "title": "Get Purchase Details",
  "path": "/v1/purchase/{purchase_id}",
  "description": "After a purchase has been completed (either via hosted payment or API), retrieve the details of that purchase",
  "request": {
    "headers": [
      ...sharedHeaders
    ],
    "pathParams": [
      {
        "key": "purchase_id",
        "required": true,
        "type": "string",
        "description": "ID of the completed purchase to retrieve details for",
        "example": "lX8RkQmK49iPVWRt9gdc"
      }
    ]
  },
  "responses": {
    "200": {
      "description": "Successful response",
      "content": {
        "application/json": {
          "schema": {
            "type": "object",
            "properties": {
              "policy_id": {
                "type": "string",
                "description": "ID of the completed purchase",
                "example": "lX8RkQmK49iPVWRt9gdc"
              },
              "status": {
                "type": "string",
                "enum": [
                  "pending",
                  "paid",
                  "cancelled",
                  "refunded"
                ],
                "description": "Current status of the purchase",
                "example": "paid"
              },
              "paid_at": {
                "type": "string",
                "description": "ISO 8601 date string when the purchase was paid",
                "example": "2023-01-01T12:00:00.000Z"
              },
              "policyholder": {
                "type": "object",
                "properties": {
                  "firstname": {
                    "type": "string",
                    "description": "First name of the policyholder",
                    "example": "John"
                  },
                  "lastname": {
                    "type": "string",
                    "description": "Last name of the policyholder",
                    "example": "Doe"
                  },
                  "email": {
                    "type": "string",
                    "description": "Email address of the policyholder",
                    "example": "john.doe@example.com"
                  }
                },
                "required": [
                  "firstname",
                  "lastname",
                  "email"
                ]
              },
              "coverage_dates": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "List of coverage dates in DD/MM/YYYY format (if applicable)"
              },
              "insured_persons": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/InsuredPerson"
                },
                "description": "List of insured persons"
              },
              "product_name": {
                "type": "string",
                "description": "Name of the purchased product",
                "example": "ASSURGLISSE"
              },
              "documents": {
                "type": "object",
                "properties": {
                  "insurance_certificate": {
                    "type": "string",
                    "description": "URL to the proof of purchase document",
                    "example": "https://example.com/insurance_certificate"
                  },
                  "invoice": {
                    "type": "string",
                    "description": "URL to the invoice document",
                    "example": "https://example.com/invoice"
                  },
                  "cg": {
                    "type": "string",
                    "description": "URL to the terms and conditions document",
                    "example": "https://example.com/terms"
                  },
                  "ipid": {
                    "type": "string",
                    "description": "URL to the insurance product information document",
                    "example": "https://example.com/ipid"
                  },
                  "google_wallet_pass": {
                    "type": "string",
                    "description": "URL to the Google Wallet pass",
                    "example": "https://example.com/google_wallet_pass"
                  },
                  "apple_wallet_pass": {
                    "type": "string",
                    "description": "URL to the Apple Wallet pass",
                    "example": "https://example.com/apple_wallet_pass"
                  }
                },
                "required": [
                  "insurance_certificate",
                  "invoice",
                  "cg",
                  "ipid",
                  "google_wallet_pass",
                  "apple_wallet_pass"
                ]
              },
              "errors": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/EntityError"
                },
                "description": "List of errors associated with the purchase (if any)"
              }
            },
            "required": [
              "policy_id",
              "status",
              "paid_at",
              "policyholder",
              "insured_persons",
              "product_name",
              "documents"
            ]
          }
        }
      }
    },
    "400": {
      "description": "Bad Request"
    },
    "401": {
      "description": "Unauthorized"
    },
    "500": {
      "description": "Internal Server Error"
    }
  },
  "components": {
    "schemas": {
      "PurchaseDetailsParams": {
        "type": "object",
        "properties": {
          "purchase_id": {
            "type": "string",
            "description": "ID of the completed purchase to retrieve details for",
            "example": "lX8RkQmK49iPVWRt9gdc"
          }
        },
        "required": [
          "purchase_id"
        ]
      },
      "InsuredPerson": {
        "type": "object",
        "properties": {
          "firstname": {
            "type": "string",
            "description": "First name of the insured person",
            "example": "Jane"
          },
          "lastname": {
            "type": "string",
            "description": "Last name of the insured person",
            "example": "Doe"
          }
        },
        "required": [
          "firstname",
          "lastname"
        ]
      },
      "EntityError": {
        "type": "object",
        "properties": {
          "code": {
            "type": "string",
            "description": "Error code",
            "example": "document_generation_failed/insurance_certificate"
          },
          "message": {
            "type": "string",
            "description": "Error message",
            "example": "Failed to generate insurance certificate"
          },
          "timestamp": {
            "type": "string",
            "description": "ISO 8601 date string when the error occurred",
            "example": "2023-01-01T12:00:00.000Z"
          }
        },
        "required": [
          "code",
          "message",
          "timestamp"
        ]
      }
    }
  }
}

export { getPurchaseDetails }
